import Progress from 'antd-mobile/lib/progress';
export default Progress;



// WEBPACK FOOTER //
// ./components/progress/index.tsx